export default __webpack_public_path__ + "static/media/revitPiano1.a9195ff9.jpg";